import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useContext } from 'react';
import styled from 'styled-components';
import { breakpoints } from '@awaze/design-system.utils.react';
import { AccordionContext } from './accordion.context';
import { AccordionItemContext, defaultAccordionItemContext, } from './accordionItem.context';
export const AccordionItem = ({ children, disabled = false, open = false, accordionToggleCallback = () => { }, ...rest }) => {
    const [isOpen, setIsOpen] = useState(open);
    const { darkTheme } = useContext(AccordionContext);
    const accordionItemContext = {
        ...defaultAccordionItemContext,
        open: isOpen,
        itemDisabled: disabled,
        toggleOpen: () => {
            setIsOpen(!isOpen);
            accordionToggleCallback(!isOpen);
        },
    };
    return (_jsx(AccordionItemContext.Provider, { value: accordionItemContext, children: _jsx(AccordionItemStyled, { "data-testid": "accordion-item", ...rest, darkTheme: darkTheme, children: children }) }));
};
const AccordionItemStyled = styled.div `
  color: ${({ theme, darkTheme }) => darkTheme ? theme.ColorWhiteOpacity100 : theme.ColorGrey800};

  border-top: 1px solid
    ${({ theme, darkTheme }) => darkTheme ? theme.ColorWhiteOpacity20 : theme.ColorGrey100};

  &:first-child {
    border-top: none;

    @media (min-width: ${breakpoints[1]}px) {
      border-top: 1px solid
        ${({ theme, darkTheme }) => darkTheme ? theme.ColorWhiteOpacity20 : theme.ColorGrey100};
    }
  }

  &:last-child {
    border-bottom: 1px solid
      ${({ theme, darkTheme }) => darkTheme ? theme.ColorWhiteOpacity20 : theme.ColorGrey100};
  }
`;
//# sourceMappingURL=accordionItem.js.map